import { FieldContext, FieldLocator } from '@app/common/configurable-wizards';

import { isSingleChoiceRadioButtonsField, SingleChoiceRadioButtonsFieldComponent }
  from '@app/common/configurable-wizards/fields/SingleChoice/RadioButtons/SingleChoiceRadioButtonsField';

export const isMemberAccountOpeningBranchFieldInfoLocator = (fieldContext: FieldContext) => (
  isSingleChoiceRadioButtonsField(fieldContext)
  && fieldContext.field.id === 'MemberAccountOpeningBranch'
);

export const MemberAccountOpeningBranchFieldInfoLocator: FieldLocator = (context) => (
  isMemberAccountOpeningBranchFieldInfoLocator(context)
    ? SingleChoiceRadioButtonsFieldComponent
    : undefined
);
